module.exports = __webpack_public_path__ + "static/media/FeedTime_ios_1.5f9e71c8.jpg";